import React from 'react';
import { BiDotsVerticalRounded, BiSearchAlt2 } from 'react-icons/bi';
import './MenuHeader.Component.scss';
import { DarkPopover } from '../../Popover/DarkPopover';
interface Props {
  title: string;
  searchQuery?: string;
  onSearch?: (search: string) => void;
  overflowMenuItems?: React.ReactNode[];
}
export function MenuHeader(props: Props) {
  const { title, searchQuery, onSearch, overflowMenuItems } = props;
  const [isShowingSearch, setIsShowingSearch] = React.useState(false);
  const [showMenu, setShowMenu] = React.useState(false);
  const hasSearch = onSearch ? true : false;

  

  const searchClicked = () => {
    

    if (!isShowingSearch) {
      setTimeout(() => {
        document.getElementById('headerSearchField')?.focus();
      }, 300);
      setIsShowingSearch(true);
    } else {
      document.getElementById('headerSearchField')?.blur();
      if (onSearch) {
        onSearch('');
      }
      setIsShowingSearch(false);
    }
  };
  const cancelButton = isShowingSearch ? (
    <div className="cancelButton" onClick={searchClicked}>
      Cancel
    </div>
  ) : null;

  return (
    <div className={`MenuHeader ${isShowingSearch ? 'isShowingSearch' : ''}`}>
      <div className="title">{title}</div>
      {hasSearch && (
        <div className="searchArea">
          <input
            id="headerSearchField"
            onChange={(e) => onSearch && onSearch(e.target.value)}
            value={searchQuery}
            placeholder={'Search...'}
          />
          <div className="searchButton" onClick={searchClicked}>
            {cancelButton}
            <BiSearchAlt2 />
          </div>
        </div>
      )}
      {overflowMenuItems?.length && (
        <div
          className={showMenu ? "overflowMenuButton isShowing" : "overflowMenuButton"} 
          onClick={() => setShowMenu(!showMenu)}
        >
          <BiDotsVerticalRounded />
        </div>
      )}
      {showMenu && (
        <DarkPopover 
        right={13}
        top={40}
        width={100}
        clickedOutside={() => setShowMenu(false)}
        >
          {overflowMenuItems?.map((item, index) => (
            <div key={index}>{item}</div>
          ))}
        </DarkPopover>
      )}
    </div>
  );
}
